import { render, staticRenderFns } from "./menuDashboard.vue?vue&type=template&id=563e3be4"
import script from "./menuDashboard.vue?vue&type=script&lang=ts"
export * from "./menuDashboard.vue?vue&type=script&lang=ts"
import style0 from "./menuDashboard.vue?vue&type=style&index=0&id=563e3be4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports